export enum FiTooltipMode {
    Common = 0,
    Absolute = 1,
}

export enum FiTooltipContentType {
    Content = 0,
    PlainText = 1,
    InsertFile = 2,
}
